import React from 'react';
import { FieldRadioToggle } from '@spotify-internal/anchor-ds';
import { Controller, Control } from 'react-hook-form';

/**
 * Most likely, you do not need to use this component. FieldRadioToggle by itself
 * should suffice for 99% of use cases. If you find that you need the radio
 * toggle to be controlled by state, use this component.
 */
export const ControlledFieldRadioToggle = ({
  control,
  options,
  name,
  id,
  label,
}: {
  /* RHF state controller */
  control: Control;
  /* Radio inputs */
  options: { label: string; value: string }[];
  /* Radio group name */
  name: string;
  /* For accessibility, to link the label to the radio group */
  id: string;
  /* Label for radio group */
  label?: string;
}) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FieldRadioToggle aria-labelledby={id}>
          {label && (
            <FieldRadioToggle.Label id={id}>{label}</FieldRadioToggle.Label>
          )}
          {options.map(({ label: optionLabel, value }) => (
            <FieldRadioToggle.Radio
              {...field}
              name={name}
              value={value}
              key={value}
            >
              {optionLabel}
            </FieldRadioToggle.Radio>
          ))}
        </FieldRadioToggle>
      )}
    />
  );
};
